{
  "hero": {
    "eyebrow": "Actualités",
    "title": "Journal de construction Phase 1",
    "lead": "Les jalons publics suivent le plan du projet. Les entrées restent prévues jusqu'à confirmation ultérieure."
  },
  "list": { "title": "Jalons" },
  "detail": { "back": "Retour aux actualités", "related": "Plus d'actualités" },
  "items": {
    "phase-one-kickoff": {
      "date": "Sept. 2026",
      "tag": "Prévu",
      "title": "Mise en place, familiarisation et vérification des composants",
      "summary": "Finaliser le périmètre Phase 1, l'architecture, les procédures de sécurité, les achats et les contrôles de base.",
      "body": [
        "Septembre confirme exigences, plans CAO/électrique, plan capteurs, esquisse logicielle et listes de tests.",
        "Les équipes prennent en main les outils et vérifient les pièces avant l'intégration d'octobre."
      ]
    },
    "integrated-prototype": {
      "date": "Oct. 2026",
      "tag": "Prévu",
      "title": "Construction parallèle des sous-systèmes",
      "summary": "Cadre mécanique, essais électroniques au banc et modules logiciels au niveau composants prêts à intégrer.",
      "body": [
        "La mécanique fabrique la plateforme ; l'électrique teste alimentation, capteurs et communication ; le logiciel construit acquisition, contrôle et journalisation.",
        "Une vérification de fin de mois confirme la préparation pour l'intégration en eau contrôlée de novembre."
      ]
    },
    "controlled-water-testing": {
      "date": "Nov. 2026",
      "tag": "Prévu",
      "title": "Intégration et validation en eau contrôlée",
      "summary": "Tests inter-équipes : flottabilité, étanchéité, propulsion, étalonnage, journalisation et premier pipeline de visualisation.",
      "body": [
        "Novembre passe du travail par composants au comportement système en eau contrôlée.",
        "Échecs, actions correctives et risques résiduels sont consignés avant la validation de décembre."
      ]
    },
    "approved-pond-window": {
      "date": "Déc. 2026",
      "tag": "Conditionnel",
      "title": "Validation système et démo campus optionnelle",
      "summary": "Achever l'événement de test en eau contrôlée ; test campus seulement si permission, météo et sécurité le permettent.",
      "body": [
        "La validation en eau contrôlée est l'objectif requis. Un test en plan d'eau campus reste un objectif d'extension.",
        "Livrables : journaux CSV utilisables, visualisations trajet/tendance, et au moins une visualisation spatiale si la qualité des données le permet."
      ]
    },
    "ams-report-archive": {
      "date": "Janv. 2027",
      "tag": "Prévu",
      "title": "Rapport final et archive de passation",
      "summary": "Soumettre le rapport final et l'archive organisée d'ici le 31 janvier 2027.",
      "body": [
        "Janvier se concentre sur le reporting plutôt que sur du nouveau matériel.",
        "L'archive couvre CAO, câblage, code, étalonnage, essais, sécurité, maintenance et recommandations."
      ]
    }
  }
}
